export const normalizeDecimal = (value: string, fallback = '0') => {
    const normalized = value.trim().replace(/\s/g, '').replace(',', '.');

    if (!normalized) {
        return fallback;
    }

    const parsed = Number(normalized);

    return Number.isFinite(parsed) ? String(parsed).replace('.', ',') : fallback;
};
